import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_contacts",
  ref: "addStoresModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_merchant_header"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Add Contacts", -1)
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_store_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_store_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_store_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "row mb-7" }
const _hoisted_11 = { class: "col-md-6 form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Salutation", -1)
const _hoisted_13 = { class: "col-md-6 form-group" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "First Name", -1)
const _hoisted_15 = { class: "row mb-7" }
const _hoisted_16 = { class: "col-md-6 form-group" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Last Name", -1)
const _hoisted_18 = { class: "col-md-6 form-group" }
const _hoisted_19 = { class: "row mb-7" }
const _hoisted_20 = { class: "col-md-12 form-group mb-7" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Merchant Company", -1)
const _hoisted_22 = { class: "row mb-7" }
const _hoisted_23 = { class: "col-md-6 form-group" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Decision Level", -1)
const _hoisted_25 = { class: "col-md-6 form-group" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Position", -1)
const _hoisted_27 = { class: "row mb-7" }
const _hoisted_28 = { class: "col-md-6 form-group" }
const _hoisted_29 = { class: "col-md-6 form-group" }
const _hoisted_30 = { class: "row mb-7" }
const _hoisted_31 = { class: "col-md-6 form-group" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Report to", -1)
const _hoisted_33 = { class: "col-md-6 form-group" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Department", -1)
const _hoisted_35 = { class: "row mb-7" }
const _hoisted_36 = { class: "col-md-6 form-group" }
const _hoisted_37 = { class: "col-md-6 form-group" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "WhatsApp Account", -1)
const _hoisted_39 = { class: "row mb-7" }
const _hoisted_40 = { class: "col-md-6 form-group" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Fax", -1)
const _hoisted_42 = { class: "col-md-6 form-group" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Private Phone", -1)
const _hoisted_44 = { class: "row mb-7" }
const _hoisted_45 = { class: "col-md-6 form-group" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Other Phone", -1)
const _hoisted_47 = { class: "col-md-6 form-group" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Other Phone Notice", -1)
const _hoisted_49 = { class: "form-group mb-7" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Birthday", -1)
const _hoisted_51 = { class: "row mb-7" }
const _hoisted_52 = { class: "col-md-12 form-group mb-7" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Assistant", -1)
const _hoisted_54 = { class: "col-md-6 form-group" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Assistant Email", -1)
const _hoisted_56 = { class: "col-md-6 form-group" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Assistant Phone", -1)
const _hoisted_58 = { class: "form-group mb-7" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Overall Notes", -1)
const _hoisted_60 = { class: "row mb-7" }
const _hoisted_61 = { class: "col-md-6 form-group" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Fulfillment Order Contact ?", -1)
const _hoisted_63 = { class: "modal-footer flex-center" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Discard ")
const _hoisted_65 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_66 = {
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_67 = { class: "indicator-label" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_69 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_el_form_item, { prop: "salutation" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.salutation,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.salutation) = $event)),
                          clearable: "",
                          placeholder: "Please select Salutation",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "Male",
                              value: '1'
                            }),
                            _createVNode(_component_el_option, {
                              label: "Female",
                              value: '2'
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_el_form_item, { prop: "firstname" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.firstname,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.firstname) = $event)),
                          type: "text",
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(_component_el_form_item, { prop: "lastname" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.lastname,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.lastname) = $event)),
                          type: "text",
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["fs-6 fw-bold mb-2", {
                      required:
                        _ctx.formData.phone == '' &&
                        _ctx.formData.mobile == '' &&
                        _ctx.formData.wechat == '',
                    }])
                    }, "Email", 2),
                    _createVNode(_component_el_form_item, { prop: "email" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "email",
                          modelValue: _ctx.formData.email,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.email) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode(_component_el_form_item, { prop: "merchant_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.merchant_id,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.merchant_id) = $event)),
                          filterable: "",
                          clearable: "",
                          remote: "",
                          "remote-method": _ctx.searchMerchantSourceItems,
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant_id, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "remote-method"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_el_form_item, { prop: "decision_level" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.decision_level,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.decision_level) = $event)),
                          clearable: "",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.decision_level, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode(_component_el_form_item, { prop: "position" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_autocomplete, {
                          class: "w-100",
                          modelValue: _ctx.formData.position,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.position) = $event)),
                          modelModifiers: { trim: true },
                          clearable: "",
                          "fetch-suggestions": _ctx.querySearchAsync,
                          placeholder: _ctx.$t('common.plsEnter')
                        }, null, 8, ["modelValue", "fetch-suggestions", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["fs-6 fw-bold mb-2", {
                      required:
                        _ctx.formData.email == '' &&
                        _ctx.formData.mobile == '' &&
                        _ctx.formData.wechat == '',
                    }])
                    }, "Phone", 2),
                    _createVNode(_component_el_form_item, { prop: "phone" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.phone,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.phone) = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["fs-6 fw-bold mb-2", {
                      required:
                        _ctx.formData.phone == '' &&
                        _ctx.formData.email == '' &&
                        _ctx.formData.wechat == '',
                    }])
                    }, "Mobile", 2),
                    _createVNode(_component_el_form_item, { prop: "mobile" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.mobile,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.mobile) = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode(_component_el_form_item, { prop: "report_to" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.report_to,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.report_to) = $event)),
                          clearable: "",
                          filterable: "",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.report_to, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createVNode(_component_el_form_item, { prop: "department" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_autocomplete, {
                          class: "w-100",
                          modelValue: _ctx.formData.department,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.department) = $event)),
                          modelModifiers: { trim: true },
                          clearable: "",
                          "fetch-suggestions": _ctx.querySearchAsyncDepartment,
                          placeholder: _ctx.$t('common.plsEnter')
                        }, null, 8, ["modelValue", "fetch-suggestions", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["fs-6 fw-bold mb-2", {
                      required:
                        _ctx.formData.phone == '' &&
                        _ctx.formData.email == '' &&
                        _ctx.formData.mobile == '',
                    }])
                    }, "WeChat Account", 2),
                    _createVNode(_component_el_form_item, { prop: "wechat" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.wechat,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.wechat) = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createVNode(_component_el_form_item, { prop: "whats_app" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.whats_app,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.whats_app) = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode(_component_el_form_item, { prop: "fax" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.fax,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.fax) = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createVNode(_component_el_form_item, { prop: "private_phone" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.private_phone,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.private_phone) = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createVNode(_component_el_form_item, { prop: "other_phone" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.other_phone,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.other_phone) = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createVNode(_component_el_form_item, { prop: "other_phone_notice" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.other_phone_notice,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.other_phone_notice) = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createVNode(_component_el_form_item, { prop: "birthday" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.birthday,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.birthday) = $event)),
                        type: "date",
                        clearable: "",
                        placeholder: "Pick a date",
                        style: {"width":"100%"},
                        onChange: _cache[18] || (_cache[18] = ($event: any) => (
                      _ctx.commonChangeDefaultDate($event, _ctx.formData, 'birthday')
                    ))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createVNode(_component_el_form_item, { prop: "assistant" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.assistant,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.assistant) = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _createVNode(_component_el_form_item, { prop: "assistant_email" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.assistant_email,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.assistant_email) = $event)),
                          type: "email"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _hoisted_57,
                    _createVNode(_component_el_form_item, { prop: "assistant_phone" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.assistant_phone,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.assistant_phone) = $event)),
                          type: "text"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _createVNode(_component_el_form_item, { prop: "overall_notes" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.overall_notes,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.overall_notes) = $event)),
                        type: "textarea"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _createVNode(_component_el_form_item, { prop: "is_fulfillment_order_contact" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.formData.is_fulfillment_order_contact,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.is_fulfillment_order_contact) = $event)),
                          "active-value": 1,
                          "inactive-value": 0,
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-light me-3",
                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _hoisted_64,
                _createElementVNode("span", _hoisted_65, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ])
              ]),
              _createElementVNode("button", _hoisted_66, [
                _createElementVNode("span", _hoisted_67, [
                  _hoisted_68,
                  _createElementVNode("span", _hoisted_69, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ]),
                _hoisted_70
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}